<template lang="pug">

    tbody

        //- View
        tr
            td
                strong Kontaktperson
            td {{ viewValue | truncate(16) }}
            td.right.aligned

                a(v-if="$route.name !== 'quality-rating'" v-on:click='showModal()')
                    i.edit.icon

                modal(ref='modal')

                    //- Header
                    span(slot="header") Kontaktperson bearbeiten

                    //- Form
                    form.ui.form(slot="content" v-on:submit.prevent="save()")
                        person-dropdown-field(
                            label='Kontaktperson'
                            v-bind:company-model='companyModel'
                            v-bind:person-models='personModels'
                            v-model='contact'
                        )

                    //- Actions
                    action-row(
                        slot="footer"
                        v-on:cancel="cancel()"
                        v-on:save="save()"
                    )

</template>

<script>
    import { full_name } from '@/utils/person'
    import ActionRow from '@/components/form/ActionRow.vue'
    import Modal from '@/components/app/Modal.vue'
    import PersonDropdownField from '@/components/persons/DropdownField'

    //noinspection ReservedWordAsName,JSUnusedGlobalSymbols
    export default {

        components: { ActionRow, Modal, PersonDropdownField },

        computed: {
            contactPerson() {
                return this.personModels.find(person => person.id === this.productModel.contact)
            },
            viewValue() {
                return this.contactPerson ? full_name(this.contactPerson) : '-'
            }
        },

        created() {
            this.contact = this.productModel.contact || 0
        },

        data() {
            return {
                contact: 0
            }
        },

        methods: {

            cancel() {
                this.$refs.modal.close()
            },

            save() {
                // Payload erstellen
                const model = { ...this.productModel, contact: this.contact }

                // Speichern
                this.$store.dispatch('products/update', { id: model.id, model }).then(() => {
                    this.$refs.modal.close()
                    this.$growl.success('Kontaktperson wurde gespeichert')
                }).catch(e => {
                    this.$growl.fatal('Kontaktperson konnte nicht gespeichert werden. Bitte an den Support wenden', e)
                })
            },

            showModal() {
                this.$refs.modal.show()
            }
        },

        props: {
            companyModel: {
                type: Object,
                required: true
            },
            personModels: {
                type: Array,
                required: true
            },
            productModel: {
                type: Object,
                required: true
            }
        },

        watch: {
            'productModel.contact'(value) {
                this.contact = value || 0
            }
        }

    }

</script>
